import _ from "lodash";
/* external */
import { useQuery } from "@apollo/client";

/* internal */

/* relative */

const defaultParseData = data => data;

const useFetchQuery = ({
  query,
  variables = {},
  parseData = defaultParseData,
  skipCondition = false,
  fetchPolicy = "cache-and-network",
  context = {},
}) => {
  const { data, error, networkStatus, refetch, fetchMore } = useQuery(query, {
    fetchPolicy,
    variables,
    skip: skipCondition, // skip execution if dependency is missing,
    context,
  });

  return {
    data: !_.isNil(data) ? parseData(data) : null,
    loading: networkStatus == 1 || networkStatus == 2,
    fetchMore,
    isFetchingMoreData: networkStatus === 3,
    error,
    refetch,
    hasData: !_.isEmpty(data),
    variables,
    networkStatus,
  };
};

export default useFetchQuery;
